import { IMaskInput } from 'react-imask'
import { cn } from "@/lib/class-control"
import { ControllerRenderProps, FieldValues } from "react-hook-form"

interface InputRgProps<T extends FieldValues> {
  field: ControllerRenderProps<T>
  placeholder?: string
  className?: string
}

export default function InputRg<T extends FieldValues>({
  field,
  placeholder = "Digite o número do seu RG",
  className,
  ...props
}: InputRgProps<T>) {
  return (
    <div className="flex items-center w-full px-3 py-2 border border-gray-600 rounded bg-[#15203c] text-white focus-within:ring-2 focus-within:ring-green-400">
      <IMaskInput
        mask="0000000000"
        name={field.name}
        inputRef={field.ref}
        value={field.value == null ? "" : String(field.value)}
        onAccept={(value) => field.onChange(value)}
        placeholder={placeholder}
        className={cn(
          "flex-1 bg-transparent outline-none text-sm text-white placeholder-gray-400",
          "autofill:bg-transparent autofill:shadow-[0_0_0_1000px_#15203c_inset] autofill:[-webkit-text-fill-color:#fff]",
          "[&:-webkit-autofill]:bg-transparent [&:-webkit-autofill]:shadow-[0_0_0_1000px_#15203c_inset] [&:-webkit-autofill]:[-webkit-text-fill-color:#fff]",
          "[&:-webkit-autofill:hover]:shadow-[0_0_0_1000px_#15203c_inset] [&:-webkit-autofill:focus]:shadow-[0_0_0_1000px_#15203c_inset]",
          className
        )}
        {...props}
      />
    </div>
  )
}

InputRg.displayName = "InputRg"